import { createAsyncThunk } from '@reduxjs/toolkit'
import { AppDispatch, RootState } from '../store'
import {
  setConnectionStatus,
  addMessage,
  setError,
} from '../slices/adjudicationMessageSlice'
import { SenderType } from '@/constants/chat'
import WebSocketManager from '../../services/websocketManager'

const wsManager = WebSocketManager.getInstance()

export const connectAdjudicationWebSocket = createAsyncThunk<
  void,
  { jwtToken: string; decisionId: string; phaseId?: string },
  { dispatch: AppDispatch; state: RootState }
>(
  'websocket/connectAdjudication',
  async ({ jwtToken, decisionId, phaseId }, { rejectWithValue }) => {
    try {
      return await wsManager.connectToAdjudication(
        jwtToken,
        decisionId,
        phaseId
      )
    } catch (error) {
      console.error('Failed to connect to adjudication websocket:', error)
      return rejectWithValue(
        (error as Error).message ||
          'Failed to connect to adjudication websocket'
      )
    }
  }
)

export const sendAdjudicationMessage = createAsyncThunk<
  void,
  { message: string; senderName: string },
  { dispatch: AppDispatch; state: RootState }
>(
  'websocket/sendAdjudicationMessage',
  async ({ message, senderName }, { rejectWithValue, dispatch }) => {
    dispatch(
      addMessage({
        id: Date.now(),
        message: message,
        user: '',
        created_at: new Date().toISOString(),
        streaming: false,
        final: true,
        senderName: senderName,
        senderType: SenderType.Professor,
      })
    )
    const success = wsManager.sendMessage('adjudication', {
      message,
      senderName,
    })
    if (!success) {
      return rejectWithValue('WebSocket is not connected')
    }
  }
)

export const disconnectAdjudicationWebSocket = createAsyncThunk<
  void,
  void,
  { dispatch: AppDispatch; state: RootState }
>('websocket/disconnectAdvisor', async (_, { dispatch }) => {
  try {
    await wsManager.disconnect('adjudication')
    dispatch(setConnectionStatus(false))
  } catch (error) {
    const errorMessage =
      error instanceof Error
        ? error.message
        : 'Unknown error disconnecting advisor WebSocket'
    dispatch(setError(errorMessage))
  }
})
